import { SelfServeNodes } from "@faire/help-center-self-serve/types";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Application } from "@faire/web--source/slate/icons/foundation/Application";
import React from "react";

import { BulkDownloadIA } from "../instantAnswers/invoicesAndPayments-bulkDownload";
import { InvoiceBasicsIA } from "../instantAnswers/invoicesAndPayments-invoiceBasics";
import { WhereToFindInvoicesL3IA } from "../instantAnswers/invoicesAndPayments-whereToFindInvoicesL3";

export const useInvoicesRetailerNodes = (): SelfServeNodes => {
  const { strictLocalize } = useStrictLocalization();
  const articles = useArticles();
  return {
    Invoices: {
      id: "Invoices",
      label: strictLocalize({
        defaultMessage: "Invoices",
        description: {
          text: "A top level issue node in the full page self-serve experience of Faire's Help Center",
        },
      }),
      icon: <Application fontSize="24px" color="faireBlack" />,
      children: ["AboutInvoices", "HowToFindAnInvoice", "DownloadInvoices"],
      level: 1,
      sidebarTitle: strictLocalize({
        defaultMessage: "Invoices issue",
        description: {
          text: "Title for displaying on the order summary sidebar",
        },
      }),
    },
    HowToFindAnInvoice: {
      id: "HowToFindAnInvoice",
      label: strictLocalize({
        defaultMessage: "How to find an invoice",
        description: {
          text: "A third level issue node in the full page self-serve experience of Faire's Help Center",
        },
      }),
      instantAnswer: WhereToFindInvoicesL3IA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.UNDERSTANDING_ORDER_INVOICE],
      level: 3,
    },
    DownloadInvoices: {
      id: "DownloadInvoices",
      label: strictLocalize({
        defaultMessage: "Download invoices",
        description: {
          text: "A third level issue node in the full page self-serve experience of Faire's Help Center",
        },
      }),
      instantAnswer: BulkDownloadIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.UNDERSTANDING_ORDER_INVOICE],
      level: 3,
    },
    AboutInvoices: {
      id: "AboutInvoices",
      label: strictLocalize({
        defaultMessage: "About invoices",
        description: {
          text: "A second level issue node in the full page self-serve experience of Faire's Help Center",
        },
      }),
      instantAnswer: InvoiceBasicsIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.UNDERSTANDING_ORDER_INVOICE],
      level: 2,
    },
  };
};
